export default __webpack_public_path__ + "static/media/brain.9cfdaf9a.png";